<template>
  <div class="fav-record-main">
    <a-spin class="page-load" v-if="pageLoad" />
    <div class="main-box">
      <div class="result-count">
        <span
          >共<b>{{ rowCount }}</b
          >人</span
        >
        <div class="sort">
          <span :class="sorts[0] ? 'cur' : ''" @click="onSorts(0)">唱片数</span>
          <span :class="sorts[1] ? 'cur' : ''" @click="onSorts(1)">名称</span>
        </div>
      </div>

      <!-- 列表 -->
      <div class="company-list">
        <div
          v-for="(item, index) in recordList"
          :key="index"
          class="company-cell"
        >
          <div class="index">{{ index + 1 }}</div>
          <div class="pic">
            <router-link
              :to="'/musician-detail/' + encodeURIComponent(item['@id'])"
            >
              <img v-if="item.img" :src="item.img" alt="" />
              <div
                v-else
                :class="'base-pic-placeholder bg' + parseInt(Math.random() * 6)"
              >
                {{ item.name["@value"].substring(0, 1) }}
              </div>
            </router-link>
          </div>
          <div class="info"><router-link
                :to="'/musician-detail/' + encodeURIComponent(item['@id'])"
                >
            <div class="name">
              {{ item.name["@value"] }}
            </div>
            <div class="des">
               {{item.briefBiography.replace(/,/g,'，').replace(/[.]/g,'。').split('（来源')[0]}}
            </div>
            </router-link>
          </div>
          <div class="count-c" v-if="item.phonoAmt">
            <b>{{ item.phonoAmt }}</b
            >唱片
          </div>
          <!-- <div class="count-c" v-if="item.workAmt">
            <b>{{item.workAmt}}</b>歌曲
          </div> -->
          <div class="act">
            <span class="play"></span>
            <span
              :class="item.isFavorite ? 'fav cur' : 'fav'"
              @click="handleFav(index)"
            ></span>
            <span class="share"></span>
          </div>
        </div>
        <div class="page-box">
          <a-pagination
            :total="pagerCount"
            :current="currentPage"
            @change="onChange"
            show-quick-jumper
            show-less-items
          />
        </div>
      </div>
    </div>
    <Player ref="player"/>
  </div>
</template>

<script>
import { baseRecordPic } from "@/util/basePic";
import { collMcList, collFav, ncollFav } from "@/api";
import Player from "@/components/player";
export default {
  components: {
    Player
  },
  data() {
    return {
      pageLoad: false,
      searchType: 1, // 检索类型 1：简单检索，2：高级检索，3：专业检索
      searchParams: {}, // 检索参数
      hasAudio: false,
      onlyShowPlay: false,
      baseRecordPic,
      listType: 1,
      subjectCount: 0,
      subjectCurrent: -1,
      subjectDict: [],
      plCount: 0,
      plCurrent: -1,
      plDict: [],
      showMobileFilter: false,
      langCount: 0,
      langCurrent: -1,
      langDict: [],
      facesTitleKey: [
        { key: "subject", title: "主题分类" },
        { key: "pl", title: "出版地" },
        { key: "lang", title: "语种" },
      ],
      rowCount: 0,
      pagerCount: 1,
      currentPage: 1,
      totalPage: 10, // 每页总数
      recordList: [],
      showAll: [true, true, false, false, false, false],
      showAllSpan: [false, false, false, false, false, false],
      filterKeys: [],
      sorts: [true, false, false],
      countnum: 0,
      isFav: false,
      visible: false,
      cm: [],
      countnum: 0,
      recordList: [],
      showAll: [true, true, false, false, false, false],
      filterKeys: [],
      sorts: [true, false, false],
    };
  },
  mounted() {
    this.$nextTick(() => {
      document.body.addEventListener("click", () => {
        this.showMobileFilter = false;
      });
      this.searchParams = this.commonParamsHandling();
      this.query();
    });
  },
  methods: {
    onChange(current) {
      // 页码点击
      this.currentPage = current;
      this.query(false);
    },
    initData(flag = true, flag2 = true) {
      // 初始化
      this.recordList = [];
      this.rowCount = 0;
    },
    onParamsHandle() {
      // 检索参数设置
      // 初始化
      this.initData();
      this.searchParams = this.commonParamsHandling();
      if (this.hasAudio)
        // this.searchParams.facet = { hasAudio: this.hasAudio + "" };
        this.searchParams.resouce = { PLAY: "1" };
      // 排序
      this.searchParams.sorts = {};
      if (this.sorts[0]) this.searchParams.sorts.CNT = 0;//数量倒排
      if (this.sorts[1]) this.searchParams.sorts.NAME = 1;
      // 页码翻页
      this.searchParams.pager.pageth = this.currentPage;
      this.searchParams.pager.pageSize = this.totalPage;
      if (this.filterKeys.length < 1) return;
      let sim = false;
      this.filterKeys.forEach((item, index) => {
        const dict = item.dict;
        // 简单检索
        if (dict == "keyword") {
          this.searchParams.searchType = 1;
          this.searchParams.freetext = item.text;
        }
        // 分面参数
        if (dict.indexOf("Dict") != -1) {
          this.searchParams.facet[dict.replace("Dict", "").toUpperCase()] =
            item.text;
        }
      });
    },
    async query(facetsFlag = true) {
      // this.pageLoad = true;是否刷新画面
      // 参数设置
      this.onParamsHandle();
      const res = await collMcList(this.searchParams);
      if (res) {
        this.pageLoad = false;
      }
      const result = res.data;
      this.recordList = result.datas;
      // 总数
      this.rowCount =
        result.pager && result.pager.rowCount ? result.pager.rowCount : 0;
      // 页码
      this.pagerCount =
        result.pager && result.pager.rowCount ? result.pager.rowCount : 1;
    },
    async handleFav(index) {
      if (
        !localStorage.getItem("token") ||
        localStorage.getItem("token") == ""
      ) {
        this.$message.open({
          content: "您还未登录,登陆后才能操作",
        });
        return;
      }
      const res = this.recordList[index].isFavorite
        ? await ncollFav({ uri: this.recordList[index]["@id"] })
        : await collFav({ uri: this.recordList[index]["@id"] });
      //console.log(res);
      this.recordList.splice(index, 1, {
        ...this.recordList[index],
        isFavorite: !this.recordList[index].isFavorite,
      });
      this.isFavorite = !this.isFavorite;

      this.$parent.coll(this.recordList[index].isFavorite);
      this.query();
    },
    onCountHnadle(key) {
      // 统计数量
      this[key + "Count"] = 0;
      this[key + "Dict"].forEach((item, index) => {
        this[key + "Count"] += item.count;
      });
    },
    showAllHandle(a) {
      this.showAll.splice(a, 1, !this.showAll[a]);
      let count = 0;
      this.showAll.forEach((item) => {
        if (item) {
          count++;
        }
      });
      if (count > 3) {
        let flag = false;
        this.showAll.forEach((item, index) => {
          if (item && index !== a && !flag) {
            flag = true;
            this.showAll.splice(index, 1, false);
          }
        });
      }
    },
    onSorts(n) {
      // 排序
     // 排序
      this.sorts.splice(n, 1, !this.sorts[n]);
      let allFalse = 1
      this.sorts.forEach((item, index) => {
        if (n != index) {
          this.sorts[index] = false;
        }
        if(item == true){
          allFalse = 2
        }
      });
      if(allFalse == 1){
        this.sorts[0] = true;
      }
      this.query(false);
    },
    deleteFilter(index) {
      this[
        this.filterKeys[index].dict.substring(
          0,
          this.filterKeys[index].dict.search("Dict")
        ) + "Current"
      ] = -1;
      this.filterKeys.splice(index, 1);
    },
    handleOk() {
      window.location.href =
        this.GLOBAL.BASE_LOGIN_URL +
        window.location.href;
    },
    handleCancel() {
      this.visible = false;
    },
    handleFilter(index, key) {
      this[key + "Current"] = index;
      const _i = this.filterKeys.findIndex((item) => {
        return item.dict === key + "Dict";
      });
      if (_i !== -1) {
        if (index === -1) {
          this.filterKeys.splice(_i, 1);
        } else {
          this.filterKeys.splice(_i, 1, {
            dict: key + "Dict",
            text: this[key + "Dict"][index].name,
          });
        }
      } else {
        this.filterKeys.push({
          dict: key + "Dict",
          text: this[key + "Dict"][index].name,
        });
      }
    },
  },
};
</script>

